export default {
  headerTasks: 'Maintenance tasks',
  headerAttachments: 'Attachments',
  noAssetBlobs: 'Asset {asset} has no documentation.',
};
